import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import { useInvalidateShopDomains } from "./use-shop-domains";

export default function useRemoveDomain(shop: ShopDto) {
	return useApiMutation(
		"delete",
		"/shops/{shopId}/preferences/notifications/domains/{name}",
		{
			invalidate: useInvalidateShopDomains(shop.id),
			mapVariables: (domainName: string) => ({
				params: { path: { shopId: shop.id, name: domainName } },
			}),
		},
	);
}
